import { render, staticRenderFns } from "./PrivacyPolicyContent.vue?vue&type=template&id=414de6f0&scoped=true"
import script from "./PrivacyPolicyContent.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyContent.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyContent.vue?vue&type=style&index=0&id=414de6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "414de6f0",
  null
  
)

export default component.exports